module.exports = __webpack_public_path__ + "static/carousel4.6e920833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/carousel/carousel4.jpg
// module id = 708
// module chunks = 168707334958949